export default "__VITE_ASSET__6091d797__"